var BASE_URL = "/api";
if (window._env_ && window._env_.VUE_APP_BASE_URL) {
  BASE_URL = window._env_.VUE_APP_BASE_URL;
} else if (process.env.VUE_APP_BASE_URL) {
  BASE_URL = process.env.VUE_APP_BASE_URL;
}


export const API_ENDPOINTS = {
  experiments: `${BASE_URL}/experiments`,
  experiment: (id) => `${BASE_URL}/experiments/${id}`,
  users: `${BASE_URL}/users`,
  user: (id) => `${BASE_URL}/users/${id}`,
  comments: `${BASE_URL}/comments`,
  comment: (id) => `${BASE_URL}/comments/${id}`,
  queryExecutor: `${BASE_URL}/query`,
  files: `${BASE_URL}/files`,
  filesTree: `${BASE_URL}/files/tree`,
  file: (id) => `${BASE_URL}/file/${id}`,
  displayImage: (fileId) => `${BASE_URL}/display-images/${fileId}`,
  displayImageStatus: (fileId) => `${BASE_URL}/display-images/${fileId}/status`,
  displayImageOrder: (fileId) => `${BASE_URL}/display-images/${fileId}/order`,
  entityDisplayImages: (entityType, entityId) => `${BASE_URL}/entities/${entityType}/${entityId}/display-images`,
  associativeComments: `${BASE_URL}/associative/comments`,
  project: (id) => `${BASE_URL}/projects/${id}`,
  projectHierarchy: (id) => `${BASE_URL}/projects/${id}/hierarchy`,
  projectStructureElements: (id) => `${BASE_URL}/projects/${id}/structure/elements`,
  projectStructureElement: (id) => `${BASE_URL}/project-structure/elements/${id}`,
  projectStructureElementById: (id) => `${BASE_URL}/project-structure/elements/${id}`,
  projectStructureElementMove: (elementId) => `${BASE_URL}/project-structure/elements/${elementId}/move`,
  projectStructureElementComments: (elementId) => `${BASE_URL}/project-structure/elements/${elementId}/comments`,
  projectStructureComment: (commentId) => `${BASE_URL}/project-structure/comments/${commentId}`,
  projectStructureElementFilesInitUpload: (elementId) => `${BASE_URL}/project-structure/elements/${elementId}/files/init-upload`,
  projectStructureElementFilesRefreshUploadUrls: (elementId) => `${BASE_URL}/project-structure/elements/${elementId}/files/refresh-upload-urls`,
  projectStructureElementFilesCompleteUpload: (elementId) => `${BASE_URL}/project-structure/elements/${elementId}/files/complete-upload`,
  projectStructureElementFilesFinalizeUpload: (elementId) => `${BASE_URL}/project-structure/elements/${elementId}/files/finalize-upload`,
  projectStructureAllowedChildTypes: (id) => `${BASE_URL}/projects/${id}/structure/allowed-child-types`,
  projectStructureExperimentTargets: (id) => `${BASE_URL}/projects/${id}/structure/experiment-targets`,
  projects: `${BASE_URL}/projects`,
  projectTemplates: `${BASE_URL}/project-templates`,
  projectTemplate: (id) => `${BASE_URL}/project-templates/${id}`,
  locations: `${BASE_URL}/locations`,
  location: (id) => `${BASE_URL}/locations/${id}`,
  projectExperiments: (id) => `${BASE_URL}/projectExperiments/${id}`,
  locationExperiments: (id) => `${BASE_URL}/locationExperiments/${id}`,
  allInstruments: `${BASE_URL}/allInstruments`,
  instruments: `${BASE_URL}/instruments`,
  instrument: (id) => `${BASE_URL}/instrument/${id}`,
  instrumentCard: (instrumentId) => `${BASE_URL}/instrument/${instrumentId}/card`,
  rentalPlaces: `${BASE_URL}/rental-places`,
  rentalPlace: (id) => `${BASE_URL}/rental-places/${id}`,
  rentalPlaceInstruments: (id) => `${BASE_URL}/rental-places/${id}/instruments`,
  workflows: `${BASE_URL}/workflows`,
  workflow: (id) => `${BASE_URL}/workflows/${id}`,
  actions: `${BASE_URL}/actions`,
  action: (id) => `${BASE_URL}/actions/${id}`,
  actionExperiments: (id) => `${BASE_URL}/actions/${id}/experiments`,
  metadataLists: `${BASE_URL}/metadata-lists`,
  metadataList: (id) => `${BASE_URL}/metadata-lists/${id}`,
  metadataListKeys: (id) => `${BASE_URL}/metadata-lists/${id}/keys`,
  metadataKeys: `${BASE_URL}/metadata-keys`,
  metadataKey: (id) => `${BASE_URL}/metadata-keys/${id}`,
  mdlists: `${BASE_URL}/mdlists`,
  mdlist: (id) => `${BASE_URL}/mdlists/${id}`,
  mdkeys: (mdlist_Id) => `${BASE_URL}/mdlists/${mdlist_Id}/keys`,
  mdkey: (keyId) => `${BASE_URL}/mdkeys/${keyId}`,
  keyValues: (md_list_id) => `${BASE_URL}/keyvalues/${md_list_id}`,
  mdvaluesWithKey: `${BASE_URL}/mdvalues/with_key`,
  mdvalues: (id) => `${BASE_URL}/mdvalues/${id}`,
  mdlistChildren: (id) => `${BASE_URL}/mdlists/${id}/children`,
  unasociatedChildrenList: (parent_id) => `${BASE_URL}/mdlist/${parent_id}/unassociated-children`,
  mdlistChildrenList: `${BASE_URL}/mdlist/children`,
  defaultKeys: (md_list_id) => `${BASE_URL}/defaultkeys/${md_list_id}`,
  nonDefaultKeys: (md_list_id) => `${BASE_URL}/nondefaultkeys/${md_list_id}`,
  createSeries: `${BASE_URL}/create-series`,
  filteredExperiments: `${BASE_URL}/filtered-experiments`,
  experimentFilterOptions: `${BASE_URL}/experiment-filter-options`,
  experimentPath: (id) => `${BASE_URL}/experiment-path/${id}`,
  projectWorkflows: (id) => `${BASE_URL}/project-workflows/${id}`,
  folders: `${BASE_URL}/folder`,
  folder: (id) => `${BASE_URL}/folder/${id}`,
  zipFiles: `${BASE_URL}/filesZip`,
  entraUser:`${BASE_URL}/user/from_entra`,
  projectMemberships: `${BASE_URL}/project-membership`,
  projectMembership: (id) => `${BASE_URL}/project-membership/${id}`,
  projectStructureTypes: `${BASE_URL}/project-structure/types`,
  projectStructureType: (id) => `${BASE_URL}/project-structure/types/${id}`,
  projectStructureSets: `${BASE_URL}/project-structure/sets`,
  projectStructureSet: (id) => `${BASE_URL}/project-structure/sets/${id}`,
  projectStructureSetRules: (setId) => `${BASE_URL}/project-structure/sets/${setId}/rules`,
  projectStructureSetRule: (setId, ruleId) => `${BASE_URL}/project-structure/sets/${setId}/rules/${ruleId}`,
  materials: `${BASE_URL}/material`,
  material: (id) => `${BASE_URL}/material/${id}`,
  materialProject: `${BASE_URL}/material-project`,
  experimentMdlists: `${BASE_URL}/mdlist-experiments`,
  linkedExperiments: `${BASE_URL}/experiment-link`,
  filter: `${BASE_URL}/filter`,
  path: `${BASE_URL}/path`,
  linkedParents: `${BASE_URL}/experiment-link-parent`,
  actionInfo:  (id) => `${BASE_URL}/action_info/${id}`,
  workflowActions: (id) => `${BASE_URL}/workflows/${id}/actions`,
  workflowActionsReorder: (id) => `${BASE_URL}/workflows/${id}/actions/reorder`,
  workflowActionMove: (workflowId, actionId) => `${BASE_URL}/workflows/${workflowId}/actions/${actionId}/move`,
  materialWorkflow: `${BASE_URL}/material-workflow`,
  allRecords:  `${BASE_URL}/all-records`,
  records: `${BASE_URL}/records`,
  recordSets: `${BASE_URL}/recordsets`,
  record: (id) => `${BASE_URL}/records/${id}`,
  recordTypes: `${BASE_URL}/record-types`,
  recordType: (id) => `${BASE_URL}/record-types/${id}`,
  recordMdlists: `${BASE_URL}/record-metadata-lists`,
  locationInstruments: (id) => `${BASE_URL}/loaction/instruments/${id}`,
  elementsExperiments: (id) => `${BASE_URL}/experiments-from-structure-element/${id}`,
  
  // Tabular dataset endpoints
  tabularSchemas: `${BASE_URL}/tabular-schemas`,
  tabularSchema: (schemaId) => `${BASE_URL}/tabular-schemas/${schemaId}`,
  experimentDatasets: (experimentId) => `${BASE_URL}/experiments/${experimentId}/tabular-datasets`,
  datasetImportPreview: (experimentId) => `${BASE_URL}/experiments/${experimentId}/tabular-datasets/preview`,
  tabularDataset: (datasetId) => `${BASE_URL}/tabular-datasets/${datasetId}`,
  tabularJob: (jobId) => `${BASE_URL}/tabular-jobs/${jobId}`,
  datasetRows: (datasetId) => `${BASE_URL}/tabular-datasets/${datasetId}/rows`,
  datasetExports: (datasetId) => `${BASE_URL}/tabular-datasets/${datasetId}/exports`,
  tabularJobDownload: (jobId) => `${BASE_URL}/tabular-jobs/${jobId}/download`,
  tabularJobCancel: (jobId) => `${BASE_URL}/tabular-jobs/${jobId}/cancel`,

  // Graph API endpoints
  graphNodes: `${BASE_URL}/graph/nodes`,
  graphNodeEdges: (nodeId) => `${BASE_URL}/graph/nodes/${nodeId}/edges`,
  graphMap: `${BASE_URL}/graph/map`,
  graphFullMap: `${BASE_URL}/graph/full-map`,
  graphEdges: `${BASE_URL}/graph/edges`,
  graphRelationTypes: `${BASE_URL}/graph/relation-types`,
  graphNodeKinds: `${BASE_URL}/graph/node-kinds`,
};

export { BASE_URL };
